import React from 'react';
import { calculateSKS, calculateOtpadObsh, calculateOtpadTek, isSumValid } from './utils';
import DecimalInput from '../../fields/DecimalInput';

const DataSection = ({
  displayData,
  updateDataItem,
  openModal,
  savedModalData,
  tableScrollRef,
  tableScrollPosition,
  handleTableSliderChange,
  handleTableScroll,
  handbooks = []
}) => {
  const statusColumnHeaderStyle = {
    minWidth: '70px',
    width: '70px',
    maxWidth: '70px',
    padding: '2px 4px',
    textAlign: 'center',
    verticalAlign: 'middle',
    overflowWrap: 'anywhere',
    whiteSpace: 'normal'
  };

  const statusColumnCellStyle = {
    minWidth: '70px',
    width: '70px',
    maxWidth: '70px'
  };

  const compactColumnStyle = {
    minWidth: '48px',
    width: '48px',
    maxWidth: '48px',
    padding: '2px 0',
    textAlign: 'center',
    verticalAlign: 'middle'
  };

  const compactWideColumnStyle = {
    minWidth: '60px',
    width: '60px',
    maxWidth: '60px',
    padding: '2px 0',
    textAlign: 'center',
    verticalAlign: 'middle'
  };

  const ageDiameterColumnStyle = {
    minWidth: '120px',
    width: '120px',
    maxWidth: '120px',
    padding: '2px 0',
    textAlign: 'center',
    verticalAlign: 'middle'
  };

  const heightColumnStyle = {
    minWidth: '118px',
    width: '118px',
    maxWidth: '118px',
    padding: '2px 0',
    textAlign: 'center',
    verticalAlign: 'middle'
  };

  return (
    <div className="group-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4>Данные</h4>
      </div>
      
      <div 
        ref={tableScrollRef}
        onScroll={handleTableScroll}
        style={{ 
          overflowX: 'auto', 
          overflowY: 'visible',
          maxWidth: '100%',
          border: '1px solid #ddd',
          borderRadius: '6px'
        }}>
        <table className="table" style={{ 
          minWidth: '890px',
          width: 'max-content',
          marginBottom: 0,
          tableLayout: 'fixed'
        }}>
          <thead>
            <tr>
              <th style={compactColumnStyle}>Ярус</th>
              <th style={compactWideColumnStyle}>Доля</th>
              <th style={compactWideColumnStyle}>Порода</th>
              <th style={ageDiameterColumnStyle}>Ср. возраст, лет</th>
              <th style={heightColumnStyle}>Ср. высота, м</th>
              <th style={ageDiameterColumnStyle}>Ср. диаметр, см</th>
              <th style={statusColumnHeaderStyle}>I (здор)</th>
              <th style={statusColumnHeaderStyle}>II (ослаб)</th>
              <th style={statusColumnHeaderStyle}>III (с.осл.)</th>
              <th style={statusColumnHeaderStyle}>IV (усых)</th>
              <th style={statusColumnHeaderStyle}>VA (св.сс.)</th>
              <th style={statusColumnHeaderStyle}>VБ (св.вв.)</th>
              <th style={statusColumnHeaderStyle}>VВ (св.бл)</th>
              <th style={statusColumnHeaderStyle}>VГ (ст.сс)</th>
              <th style={statusColumnHeaderStyle}>VД (ст.вв)</th>
              <th style={statusColumnHeaderStyle}>VЕ (ст.бл)</th>
              <th style={{ minWidth: '60px', width: '60px' }}>СКС</th>
              <th style={{ minWidth: '75px', width: '75px' }}>Отпад (общ)</th>
              <th style={{ minWidth: '75px', width: '75px' }}>Отпад (тек)</th>
              <th style={{ minWidth: '90px', width: '90px' }}>Причина/признак</th>
            </tr>
          </thead>
          <tbody>
            {displayData.data.map((item) => (
              <tr key={item.id}>
                {/* Ярус */}
                <td className="coordinate-cell" style={compactColumnStyle}>
                  <input
                    type="text"
                    value={item.yarus}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>

                {/* Доля */}
                <td className="coordinate-cell" style={compactColumnStyle}>
                  <input
                    type="text"
                    value={item.dolap}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>

                {/* Порода */}
                <td className="coordinate-cell" style={compactWideColumnStyle}>
                  <input
                    type="text"
                    value={(() => {
                      const handbook = handbooks?.find(h => h.id === 31);
                      if (handbook && handbook.references && item.kodporoda) {
                        const selectedOption = handbook.references.find(r => r.id.toString() === String(item.kodporoda));
                        return selectedOption ? selectedOption.name : item.kodporoda;
                      }
                      return item.kodporoda || '';
                    })()}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>

                {/* Ср. возраст, лет */}
                <td className="coordinate-cell" style={ageDiameterColumnStyle}>
                  <input
                    type="text"
                    value={item.vozr}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>

                {/* Ср. высота, м */}
                <td className="coordinate-cell" style={heightColumnStyle}>
                  <input
                    type="text"
                    value={item.hsr}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>

                {/* Ср. диаметр, см */}
                <td className="coordinate-cell" style={ageDiameterColumnStyle}>
                  <input
                    type="text"
                    value={item.dsr}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>

                {/* I (здор) */}
                <td className="coordinate-cell" style={statusColumnCellStyle}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    value={item.bpodolap}
                    readOnly
                    className="form-control coordinate-field"
                    style={{
                      background: item.bpodolap < 0 ? '#f8d7da' : '#f8f9fa',
                      cursor: 'not-allowed',
                      color: item.bpodolap < 0 ? '#721c24' : '#6c757d',
                      fontWeight: 'bold'
                    }}
                  />
                </td>

                {/* II (ослаб) */}
                <td className="coordinate-cell" style={statusColumnCellStyle}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                    value={item.osldolap}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'osldolap', value);
                      }
                    }}
                    placeholder="0-100"
                    className={`form-control coordinate-field ${!isSumValid(item) ? 'lp-error' : ''}`}
                  />
                </td>

                {/* III (с.осл.) */}
                <td className="coordinate-cell" style={statusColumnCellStyle}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                    value={item.sosldolap}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'sosldolap', value);
                      }
                    }}
                    placeholder="0-100"
                    className={`form-control coordinate-field ${!isSumValid(item) ? 'lp-error' : ''}`}
                  />
                </td>

                {/* IV (усых) */}
                <td className="coordinate-cell" style={statusColumnCellStyle}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                    value={item.usdolap}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'usdolap', value);
                      }
                    }}
                    placeholder="0-100"
                    className={`form-control coordinate-field ${!isSumValid(item) ? 'lp-error' : ''}`}
                  />
                </td>

                {/* VA (св.сс.) */}
                <td className="coordinate-cell" style={statusColumnCellStyle}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                    value={item.svsuhdolap}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'svsuhdolap', value);
                      }
                    }}
                    placeholder="0-100"
                    className={`form-control coordinate-field ${!isSumValid(item) ? 'lp-error' : ''}`}
                  />
                </td>

                {/* VБ (св.вв.) */}
                <td className="coordinate-cell" style={statusColumnCellStyle}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                    value={item.svvtrdolap}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'svvtrdolap', value);
                      }
                    }}
                    placeholder="0-100"
                    className={`form-control coordinate-field ${!isSumValid(item) ? 'lp-error' : ''}`}
                  />
                </td>

                {/* VВ (св.бл) */}
                <td className="coordinate-cell" style={statusColumnCellStyle}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                    value={item.svburdolap}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'svburdolap', value);
                      }
                    }}
                    placeholder="0-100"
                    className={`form-control coordinate-field ${!isSumValid(item) ? 'lp-error' : ''}`}
                  />
                </td>

                {/* VГ (ст.сс) */}
                <td className="coordinate-cell" style={statusColumnCellStyle}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                    value={item.stsuhdolap}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'stsuhdolap', value);
                      }
                    }}
                    placeholder="0-100"
                    className={`form-control coordinate-field ${!isSumValid(item) ? 'lp-error' : ''}`}
                  />
                </td>

                {/* VД (ст.вв) */}
                <td className="coordinate-cell" style={statusColumnCellStyle}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                    value={item.stvtrdolap}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'stvtrdolap', value);
                      }
                    }}
                    placeholder="0-100"
                    className={`form-control coordinate-field ${!isSumValid(item) ? 'lp-error' : ''}`}
                  />
                </td>

                {/* VЕ (ст.бл) */}
                <td className="coordinate-cell" style={statusColumnCellStyle}>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                    value={item.stburdolap}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100)) {
                        updateDataItem(item.id, 'stburdolap', value);
                      }
                    }}
                    placeholder="0-100"
                    className={`form-control coordinate-field ${!isSumValid(item) ? 'lp-error' : ''}`}
                  />
                </td>
                
                {/* СКС */}
                <td className="coordinate-cell" style={{ minWidth: '60px', width: '60px' }}>
                  <DecimalInput
                    value={calculateSKS(item)}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>
                
                {/* Отпад (общ) */}
                <td className="coordinate-cell" style={{ minWidth: '75px', width: '75px' }}>
                  <DecimalInput
                    value={calculateOtpadObsh(item)}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>
                
                {/* Отпад (тек) */}
                <td className="coordinate-cell" style={{ minWidth: '75px', width: '75px' }}>
                  <DecimalInput
                    value={calculateOtpadTek(item)}
                    readOnly
                    className="form-control coordinate-field"
                    style={{ background: '#f8f9fa', cursor: 'not-allowed' }}
                  />
                </td>
                
                {/* Причина/признак */}
                <td className="coordinate-cell" style={{ minWidth: '90px', width: '90px' }}>
                  <div 
                    className="reference-cell"
                    onClick={() => openModal(item.id)}
                    style={{ 
                      minHeight: 60, 
                      height: 'auto',
                      cursor: 'pointer',
                      background: '#f8f9fa',
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      padding: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      fontSize: '12px',
                      color: '#000000'
                    }}
                  >
                    {(() => {
                      const savedData = savedModalData[item.id];
                      if (savedData && savedData.length > 0) {
                        const hasData = savedData.some(row => {
                          const hasPriznaki = Array.isArray(row.priznaki) && row.priznaki.length > 0;
                          const hasOldPrizn = row.prizn && !Array.isArray(row.priznaki);
                          return row.prichina || row.godpovr || hasPriznaki || hasOldPrizn;
                        });
                        if (hasData) {
                          // Подсчитываем общее количество признаков
                          const totalPriznaki = savedData.reduce((sum, row) => {
                            if (Array.isArray(row.priznaki)) {
                              return sum + row.priznaki.length;
                            } else if (row.prizn && !Array.isArray(row.priznaki)) {
                              // Старый формат
                              return sum + 1;
                            }
                            return sum;
                          }, 0);
                          return `Заполнено (${savedData.length}${totalPriznaki > 0 ? `, признаков: ${totalPriznaki}` : ''})`;
                        }
                      }
                      return 'Причина/признак';
                    })()}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {/* Слайдбар для прокрутки таблицы */}
      <div style={{
        marginTop: '10px',
        padding: '10px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: '6px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <span style={{ 
          fontSize: '12px', 
          color: '#6c757d',
          minWidth: '60px'
        }}>
          Прокрутка:
        </span>
        <input
          type="range"
          min="0"
          max="100"
          value={tableScrollPosition}
          onChange={handleTableSliderChange}
          className="table-scroll-slider"
          style={{
            flex: 1
          }}
        />
        <span style={{ 
          fontSize: '12px', 
          color: '#6c757d',
          minWidth: '30px',
          textAlign: 'right'
        }}>
          {Math.round(tableScrollPosition)}%
        </span>
      </div>
    </div>
  );
};

export default DataSection;

